import { useSearchParams } from 'react-router-dom';
import ResetPasswordForm from './ResetPassword-comp';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return (
    <ResetPasswordForm token={token} />
  );
};

export default ResetPassword;